export const PATHS = {
  HOME: '/',
  CHAT: '/chat',
  SIGN_IN: '/sign-in',
  SSO_SIGN_IN: '/sso-login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_OTP: '/verify-otp',
  PROFILE: '/profile',
  MY_TWIN: '/my-twin',
  TWINS: '/twins',
  GOOGLE: '/oauth/google',
  BUY_POINTS: '/buy-points',
  SUBSCRIBED_TWINS: '/subscribed-twins',
  EXPLORE_TWINS: '/explore-twins',
  FEEDBACK: '/feedback',
  TWIN_STUDIO: '/twin-studio',
  TWIN_STUDIO_COLLECTION: '/twin-studio/collection',
  VIDEO_PLAYBACK: '/watch',
  UPDATE_TWIN: '/my-twin/update',
  MANAGE_TWIN_PLANS: '/my-twin/plan',
  CHECKOUT: '/checkout',
  TWIN_LANDING: '/get-twin',
  PACKAGES: '/my-twin/packages',
  UPGRADE_TWIN: '/get-twin-studio#pricing',
  TWIN_STUDIO_LANDING: '/get-twin-studio',
};
